import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

import countries, { Alpha3Code } from 'i18n-iso-countries';
import { useRecordContext } from 'react-admin';
import languages from '../../../constants/languages';

export interface IPCountryAllowlistParams {
  updateFreq: number;
  countries: Alpha3Code[];
}

const IPCountryAllowlist = () => {
  const record = useRecordContext();

  if (!record) return null;

  return (
    <>
      <Grid
        alignItems="baseline"
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row" gap={2} alignItems="center">
            <Typography sx={{ fontWeight: 'bold' }}>
              Data update frequency
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" gap={2} alignItems="center" flexWrap="wrap">
            <Typography>{`${record.ruleParameters.updateFreq} days`}</Typography>
          </Box>
        </Box>
      </Grid>
      <Grid
        alignItems="baseline"
        size={{
          xs: 12,
          sm: 6,
          lg: 4,
        }}
      >
        <Box display="flex" flexDirection="column">
          <Box display="flex" flexDirection="row" gap={2} alignItems="center">
            <Typography sx={{ fontWeight: 'bold' }}>
              Allowlist
            </Typography>
          </Box>
          <Box display="flex" flexDirection="row" gap={2} alignItems="center" flexWrap="wrap">
            <Typography>
              {(record.ruleParameters as IPCountryAllowlistParams)
                .countries.map((country) => countries.getName(country, languages.EN))
                .join(', ')}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </>
  );
};

export default IPCountryAllowlist;
